import { render, staticRenderFns } from "./Discovermovies.vue?vue&type=template&id=7234caf6&scoped=true&"
import script from "./Discovermovies.vue?vue&type=script&lang=js&"
export * from "./Discovermovies.vue?vue&type=script&lang=js&"
import style0 from "./Discovermovies.vue?vue&type=style&index=0&id=7234caf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7234caf6",
  null
  
)

export default component.exports